import { render, staticRenderFns } from "./ClaimSettings.vue?vue&type=template&id=6ebb4f7a&scoped=true"
import script from "./ClaimSettings.vue?vue&type=script&lang=js"
export * from "./ClaimSettings.vue?vue&type=script&lang=js"
import style0 from "./ClaimSettings.vue?vue&type=style&index=0&id=6ebb4f7a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ebb4f7a",
  null
  
)

export default component.exports